import { createContext, useContext } from 'react';

/** Configuración pública en runtime (/config.json generado por sgr-deploy). Sin secretos. */
export type AppConfig = { publicOrigin: string; version: string; env: string; features?: Record<string, boolean> };
export const DEFAULT_CONFIG: AppConfig = { publicOrigin: window.location.origin, version: 'dev', env: 'dev', features: {} };
export const AppConfigCtx = createContext<AppConfig>(DEFAULT_CONFIG);
export const useAppConfig = () => useContext(AppConfigCtx);

export async function loadConfig(): Promise<AppConfig> {
  try {
    const r = await fetch('/config.json', { cache: 'no-cache' });
    if (!r.ok) return DEFAULT_CONFIG;
    const j = (await r.json()) as Partial<AppConfig>;
    return { ...DEFAULT_CONFIG, ...j };
  } catch {
    return DEFAULT_CONFIG;
  }
}
